import { AgremoCreditBlockCreateRequest } from '../request-models/agremo-credit-block-create-request.model';
import { AgremoCreditBlockUpdateRequest } from '../request-models/agremo-credit-block-update-request.model';
import { omitUndefined } from './wire-value-utils';

/**
 * Builds the POST /admin/agremo/credits body (hub `admin-agremo-credits-controller.ts` reads `amount`,
 * `creditType`, legacy `totalCredits`, `expiresAt` and `organizationId`). Only the fields that are set are sent.
 */
export function toAgremoCreditCreateRequest(fields: AgremoCreditBlockCreateRequest): AgremoCreditBlockCreateRequest {
  return omitUndefined({
    amount: fields.amount,
    creditType: fields.creditType,
    totalCredits: fields.totalCredits,
    expiresAt: fields.expiresAt,
    organizationId: fields.organizationId,
  }) as AgremoCreditBlockCreateRequest;
}

/**
 * Builds the PUT /admin/agremo/credits/:id body: only `expiresAt` and `totalCredits` (the hub reads nothing else;
 * it recomputes `remainingCredits` itself). Only the fields that are set are sent.
 */
export function toAgremoCreditUpdateRequest(fields: AgremoCreditBlockUpdateRequest): AgremoCreditBlockUpdateRequest {
  return omitUndefined<AgremoCreditBlockUpdateRequest>({
    expiresAt: fields.expiresAt,
    totalCredits: fields.totalCredits,
  });
}
